const voicemailcsvcolumndata = [
  {
    id: "voicemail_uuid",
    title: "ID",
  },
  {
    id: "voicemail_id",
    title: "Voicemail",
    default: true,
  },
  {
    id: "voicemail_password",
    title: "password",
    default: true,
  },
  {
    id: "messages",
    title: "Messages",
    default: true,
  },
  {
    id: "voicemail_enabled",
    title: "Status",
    default: true,
  },
  {
    id: "voicemail_description",
    title: "Notes",
  },
];
export default voicemailcsvcolumndata;
